export default __webpack_public_path__ + "static/media/icons8-pin-96.358764e8.svg";